import { render } from "./Solution.vue?vue&type=template&id=0f938cbc"
import script from "./Solution.vue?vue&type=script&lang=js"
export * from "./Solution.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/Solution.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f938cbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f938cbc', __exports__)) {
    api.reload('0f938cbc', __exports__)
  }
  
  module.hot.accept("./Solution.vue?vue&type=template&id=0f938cbc", () => {
    api.rerender('0f938cbc', render)
  })

}


export default __exports__